<template>
    <div class="text-center" v-if="totalPage != null && totalPage > 0" >
        <v-pagination v-model="currentPageNumber"
          :length="totalPage" :total-visible="7" color="#E561A9"></v-pagination>
    </div>
</template>
<script>
  import { ListEvents } from "@/utilities/CommonUtilities";
  export default {
    data() {
      return {
        currentPageNumber: null,
        totalPage: null
      };
    },
    watch: {
      currentPageNumber: function (newValue, oldValue) {
        if(newValue == oldValue || this.totalPage == null) return;
        this.notifyBus.$emit(ListEvents.paginationChanged, newValue);
      }
    },
    created() {
      this.notifyBus.$on(ListEvents.setPagination, (pageInfo) => {
        this.currentPageNumber = pageInfo.currentPageNumber;
        this.totalPage = pageInfo.totalPage;
      });
    },
    inject: ["notifyBus"]
  }
</script>
<style >
  .v-pagination__item{
  font-size: 13px;
  height: 22px;
  min-width: 22px;
  padding-top: 1.0px
}
button.v-pagination__navigation{
  height: 22px;
  min-width: 22px;
}
.v-icon.v-icon{
  font-size: 15px
}
</style>
